import React, { useReducer, useEffect, useContext } from 'react'
import { setAuthorizationToken } from 'api/kiddy-connector'
import { identifierLocalStorage } from 'util/localstorage'
import { isJwtTokenValid } from 'util/helper'
import { authReducer, initialState, actionType } from 'reducers/auth'

export const AuthContext = React.createContext({ state: initialState, dispatch: () => { } })

export const AuthProvider = (props) => {
  const [state, dispatch] = useReducer(authReducer, initialState)

  useEffect(() => {
    const _ident = identifierLocalStorage.get()

    if (!_ident || !_ident.jwtToken) {
      dispatch({ type: actionType.LOGOUT })
      return
    }

    const { jwtToken, refreshToken } = _ident

    if (isJwtTokenValid(jwtToken, refreshToken)) {
      setAuthorizationToken(jwtToken)
      dispatch({ type: actionType.LOGIN })
    } else {
      dispatch({ type: actionType.LOGOUT })
    }
  }, [])

  return <AuthContext.Provider value={{ state, dispatch }} {...props} />
}

export default function useAuth() {
  return useContext(AuthContext)
}